export interface ISubMenuFormValues {
  submenuName: string
  link: string
  linkId: number | null
  icon: string
  menuName: string
  idMenu: number | null
}

export interface ISubmenu {
  id_submenu: number
  submenu_name: string
  link_id: number
  icon: string
  id_menu: number
  is_active: string
}

export const initSubMenuFormValues: ISubMenuFormValues = {
  submenuName: '',
  link: '',
  linkId: null,
  icon: '',
  menuName: '',
  idMenu: null,
}
